export const RESOURCE = 'partner';
export const ACTIONS = { Get: '' }